import { getUniversityKey } from '@/services/http';
import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';

export function initSentry() {

  Sentry.addEventProcessor((event, _hint) => {
    if (event.level === 'error') {
      return event;
    }
    return null;
  });

  Sentry.init({
    tracesSampleRate: 1.0,
    dsn: 'https://ad9f517132af1d825d492c05818674ca@sentry.dadekavan.ir/7',
    integrations: [
      Sentry.browserTracingIntegration({
        instrumentPageLoad: true,
        instrumentNavigation: true,
        beforeStartSpan: (op) => {
          // console.log('sentry::beforeStartSpan');
          return op;
        }
      }),
    ],
    ignoreErrors: [
      /findDOMNode is deprecated and will be removed in the next major release/
    ],
    beforeSend(event, _hint) {
      // console.log('sentry::beforeSend::event', event);
      if (getUniversityKey() === 'TVU') return null;
      if (event.request) {
        const status = (event.request as any).status_code;
        if ([200, 201, 400].includes(status)) {
          return null;
        }
      }
      if (event.level !== 'error') {
        return null;
      }
      return event;
    },
  });

}

export function authError(error: AxiosError<any>) {
  Sentry.withScope(scope => {
    scope.setTag('err_type', 'auth');
    scope.setTag('err_university', getUniversityKey());
    scope.setContext('app_meta', {
      url: error.config.url,
      method: error.config.method,
      message: error.message,
    });
    Sentry.captureException(error);
  });
}

export { Sentry };
